class ScentCollectionSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-scent-slider-track]');
    this.previousButton = this.querySelector('[data-scent-slider-prev]');
    this.nextButton = this.querySelector('[data-scent-slider-next]');

    if (!this.track || !this.previousButton || !this.nextButton) return;

    this.previousButton.addEventListener('click', () => this.scroll(-1));
    this.nextButton.addEventListener('click', () => this.scroll(1));
    this.track.addEventListener('scroll', () => this.updateControls(), { passive: true });
    window.addEventListener('resize', () => this.updateControls());
    this.updateControls();
  }

  scroll(direction) {
    const card = this.track.querySelector('.scent-collection-selector__card');
    const distance = card ? card.getBoundingClientRect().width : this.track.clientWidth;

    this.track.scrollBy({
      left: direction * distance,
      behavior: 'smooth',
    });
  }

  updateControls() {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    const currentScroll = this.track.scrollLeft;

    this.previousButton.disabled = currentScroll <= 1;
    this.nextButton.disabled = currentScroll >= maxScroll - 1;
  }
}

if (!customElements.get('scent-collection-slider')) {
  customElements.define('scent-collection-slider', ScentCollectionSlider);
}
